import { Toaster as ChakraToaster, Flex, Portal, Toast } from '@chakra-ui/react';
import { toaster } from './utils';

export function Toaster() {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root
            w="auto"
            px="3"
            py="2.5"
            borderRadius="full"
            boxShadow="none"
            bg="blackAlpha.80"
          >
            <Flex alignItems="center" gap="2">
              <Toast.Indicator color={toast.type === 'success' ? 'green.100' : 'red.100'} />
              {toast.title && (
                <Toast.Title color="white" fontSize="xs" fontWeight="medium">
                  {toast.title}
                </Toast.Title>
              )}
            </Flex>
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
}
